import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './styles/global.css';
import Home from "./pages/Home";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import CheckoutPage from "./pages/CheckoutPage";
import CategoryPage from "./pages/CategoryPage";
import ProductPage from "./pages/ProductPage";
import Header from "./components/customer/Header";
import Footer from "./components/customer/Footer";
import ContactPage from './pages/ContactPage';
import CartPage from './pages/CartPage';
import HelpPage from './pages/HelpPage';
import ShippingPage from './pages/ShippingPage';
import ReturnsPage from './pages/ReturnsPage';

const maintenanceMode = false;

function App() {
  if (maintenanceMode) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          backgroundColor: "#f5f5f5",
          fontFamily: "Arial",
          textAlign: "center",
          padding: "20px"
        }}
      >
        <h1 style={{ fontSize: "48px", marginBottom: "10px" }}>
          Orendion
        </h1>

        <h2 style={{ marginBottom: "20px" }}>
          Faqja është momentalisht në përpunim
        </h2>

        <p style={{ maxWidth: "500px", color: "#555" }}>
          Jemi duke punuar për të sjellë produkte dhe përvojë më të mirë për ju.
          Rikthehuni së shpejti.
        </p>
      </div>
    );
  }

  return (
    <Router>
      <div className="app">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />

            {/* PËR KLIENTËT */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/help" element={<HelpPage />} />
            <Route path="/shipping" element={<ShippingPage />} />
            <Route path="/returns" element={<ReturnsPage />} />

            {/* PËR ADMIN */}
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />

            {/* PËR KATEGORITË DHE PRODUKTET */}
            <Route path="/kategoria/:categoryName" element={<CategoryPage />} />
            <Route path="/produkti/:id" element={<ProductPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;